import React from "react";

const Footer = () => {
  return (
  <div className="footer wrapper-outer" style={{textAlign: "center" }}>
    <footer className="wrapper-inner">
      <p>&copy;2024 Cristin O'Connor</p>
    </footer>
  </div>)
}

export default Footer;